import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import ContentWrapper from 'components/common/ContentWrapper'
import { indexPageMaxContentWidth, maxContentWidth } from 'config/theme'

const StyledBannerWrapper = styled(ContentWrapper)`
  ${({ theme, $isHomePage }) => `
    width: 100%;
    overflow: hidden;
    max-width: ${maxContentWidth};
    min-height: 180px;
    height: auto;
    padding: 0;

    ${theme.breakpoints.up('lg')} {
      min-height: 325px;
      padding: 0 32px;
    }

    ${theme.breakpoints.up('xl')} {
      min-height: 360px;
      padding: 0 48px;
    }

    ${theme.breakpoints.up('xxl')} {
      min-height: 460px;
      padding: 0 64px;
    }

    ${
      $isHomePage &&
      `
      max-width: ${indexPageMaxContentWidth};
      padding-left: ${theme.spacing(4)};
      padding-right: ${theme.spacing(4)};

      ${theme.breakpoints.up('md')} {
        padding-left: ${theme.spacing(8)};
        padding-right: ${theme.spacing(8)};
      }

      ${theme.breakpoints.up('xl')} {
        padding-left: ${theme.spacing(12)};
        padding-right: ${theme.spacing(12)};
      }
    `
    }
  `}
`

const BannerWrapper = (props) => {
  const router = useRouter()
  const isHomePage = router.pathname === '/'

  return <StyledBannerWrapper {...props} $isHomePage={isHomePage} />
}

export default BannerWrapper
